import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import translateIcon from '../../images/icons/translate.svg';
import './LanguageToggle.css';

const LanguageToggle: React.FC = () => {
  const { language, toggleLanguage } = useLanguage();
  const [isHovered, setIsHovered] = useState(false);

  const alternateLanguage = language === 'es' ? 'EN' : 'ES';

  return (
    <button 
      className="language-toggle" 
      onClick={toggleLanguage}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isHovered ? (
        <span className="toggle-text">{alternateLanguage}</span>
      ) : (
        <img src={translateIcon} alt="translate" className="translate-icon" />
      )}
    </button>
  );
};

export default LanguageToggle;
